import React from "react"
import { View, Text, Window, Label, Grid, Col } from "react-ame-components"

export class LabelExample extends React.Component {
  render() {
    return (
      <Window>
        <View
          direction="column"
          align="center"
          justify="center"
          marginTop="big">
          <Grid>
            <Col columnSize={{ sm: 1, md: 3 }}></Col>
            <Col columnSize={{ sm: 10, md: 6 }}>
              <View
                backgroundColor="neutral-100"
                padding="big"
                borderRadius="small"
                shadow="level-2"
                direction="column"
                align="center">
                <Text
                  fontSize="large"
                  lineHeight="large"
                  fontWeight="bold">
                  Componente [color=primary]Label[/color]
                </Text>

                <View>
                  <Label
                    text="Exemplo do [u]label[/u]"
                    htmlFor="inputName"
                    fontWeight="medium">
                    Exemplo do [u]label[/u]
                  </Label>
                </View>
              </View>
            </Col>
            <Col columnSize={{ sm: 1, md: 3 }}></Col>
          </Grid>
        </View>
      </Window>
    )
  }
}
